import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_Property_List_By_Group } from '../../../../../../constants/APIs';
import {
  dAPI_Delete_Ingetration,
  API_TIKTOK,
} from '../../../../../../constants/APIs';
import { changeInstagram } from '../../../../../../redux/actions';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../../components/Validation';
let arr = [];
function TiktokIntegration({ visible, toggle, id, featuresUrl }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [maskData, setMaskData] = useState({
    clientId: '',
    clientSecretKey: '',
  });

  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    clientId: process.env.REACT_APP_TIKTOK_CLIENT_ID,
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
      })
      .catch((err) => console.error(err));
  }, [id]);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleCheckChange = (e) => {
    console.log(`${process.env.REACT_APP_TIKTOK_AUTHORIZATION_URL}?client_key=${inputData.clientId}&redirect_uri=https://${localStorage.getItem('host_name_url')}/${process.env.REACT_APP_TIKTOK_REDIRECT_URL}&response_type=code&scope=user.info.basic&state=test`);
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    AxiosAPI({
      method: 'post',
      url: API_TIKTOK,
      data: inputData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        toggle();
      // changeInstagram(res.data.id);
        setTimeout(() => {
         window.location.href = `${process.env.REACT_APP_TIKTOK_AUTHORIZATION_URL}?client_key=${inputData.clientId}&redirect_uri=https://${localStorage.getItem('host_name_url')}/${process.env.REACT_APP_TIKTOK_REDIRECT_URL}&response_type=code&scope=user.info.basic&state=${res.data.id}`;
        }, 300);
      }
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>
                  {id === undefined ? 'Add' : 'Update'} Tiktok Integration
                </h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mt-3">
                    <div className="integration-property text-center">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ service }) => {
  const { featuresUrl } = service;
  return featuresUrl;
};

export default injectIntl(
  connect(mapStateToProps, changeInstagram)(TiktokIntegration)
);
